import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import ChatWizard from './components/chat/ChatWizard';
import ResultView from './components/result/ResultView';
import SuccessView from './components/result/SuccessView';
import { calculateRecommendation } from './utils/logic';

/**
 * MaDaNRG Standalone Advisor
 * This version removes the landing page and starts directly with the calculator.
 */
function App() {
  const [view, setView] = useState('chat');
  const [resultData, setResultData] = useState(null);

  const handleChatComplete = (data) => {
    // Lead generation logging
    console.log('MaDaNRG | Processing results for:', data.email);
    
    const rec = calculateRecommendation(data);
    setResultData(rec);
    setView('result');
  };

  const handleReset = () => {
    setResultData(null);
    setView('chat');
  };

  return (
    <div className="min-h-screen bg-slate-950">
      <AnimatePresence mode="wait">
        {view === 'chat' && (
          <ChatWizard 
            key="chat" 
            onComplete={handleChatComplete} 
            onClose={handleReset} 
          />
        )}

        {view === 'result' && resultData && (
          <div key="result" className="relative">
            <ResultView result={resultData} />
            {/* Simple Floating Reset Button for Result View */}
            <button 
              onClick={handleReset}
              className="fixed bottom-8 left-1/2 -translate-x-1/2 px-6 py-3 bg-slate-900/80 backdrop-blur-md border border-white/10 text-slate-400 hover:text-white rounded-full text-sm font-bold transition-all z-50 shadow-2xl"
            >
              Start New Assessment
            </button>
          </div>
        )}

        {view === 'success' && (
          <SuccessView key="success" />
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;